export interface AtcConfig {
  config_name: string
  advertiser_ids: string[]
  advertiser_name?: string
  regions: string[]
  limit: number
  include_removed: boolean
}

/** The backend omits optional filters instead of serialising empty values. */
export interface AtcPayloadConfig {
  config_name: string
  advertiser_ids?: string[]
  advertiser_name?: string
  regions?: string[]
  limit: number
  include_removed: boolean
}

export interface AtcConfigSnapshot {
  exists: boolean
  configs: AtcPayloadConfig[]
}

export const ATC_MAX_CONFIGS = 10
export const ATC_MAX_LIMIT = 3000
export const ATC_DEFAULT_LIMIT = 1000

export interface AtcAdvertiserSuggestion {
  advertiser_id: string
  advertiser_name: string
}

export type AtcField = 'config_name' | 'advertiser_id' | 'regions' | 'limit'
export type AtcValidationCode =
  | 'requiredName'
  | 'requiredAdvertiserId'
  | 'advertiserIdFormat'
  | 'duplicateAdvertiserId'
  | 'regionsFormat'
  | 'limitRange'

export interface AtcDraft extends AtcConfig {
  uid: string
  advertiserIdInput: string
  showFilters: boolean
  touched: Partial<Record<AtcField, true>>
}

export type AtcDraftErrors = Partial<Record<AtcField, AtcValidationCode>>

export interface AtcConfigSummary {
  advertiserCount: number
  advertiserName: string
  regions: string[]
  limit: number
}

export interface WatchlistFormField {
  key: string
  label: string
  type: 'array' | 'string' | 'number'
  ui_component: 'text' | 'singleselect' | 'multiselect' | 'daterange' | 'toggle' | 'taginput'
  placeholder?: string
  description?: string
  required?: boolean
  options?: Array<{ value: string; label: string }>
}

export interface MetaPage {
  page_id: string
  page_name: string
}

export interface MetaDateRange {
  start: string | null
  end: string | null
}

export type MetaDraftValue = string | number | boolean | string[] | MetaDateRange | null

export interface MetaWatchlistDraft {
  uid: string
  values: Record<string, MetaDraftValue>
  touched: Partial<Record<'config_name' | 'page_id', true>>
}

export interface MetaDraftErrors {
  config_name?: 'requiredName'
  page_id?: 'requiredPageId' | 'pageIdFormat'
}
